import React from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import HeroSection from "@/components/site/HeroSection";
import AboutSection from "@/components/site/AboutSection";
import ProductsSection from "@/components/site/ProductsSection";
import WhatWeDoSection from "@/components/site/WhatWeDoSection";
import FounderSection from "@/components/site/FounderSection";
import ContactSection from "@/components/site/ContactSection";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <WhatWeDoSection />
        <FounderSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
